"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getInputValue;

function getInputValue(value, placeholder) {
  if (!value && placeholder) {
    return '';
  }

  return value || '--:-- --';
}